// Structure complète des catégories - Alliance Solidarité
// Toutes les catégories sont au même niveau

export const ALL_CATEGORIES = {
  "referent-alliance-humaine": {
    id: "referent-alliance-humaine",
    name: "Référent Alliance Humaine",
    color: "#8b5cf6",
    subcategories: []
  },
  "alimentaire": {
    id: "alimentaire",
    name: "Alimentaire",
    color: "#10b981",
    subcategories: [
      "Boucherie charcuterie",
      "Boulangerie",
      "Conservation",
      "Cuisine",
      "Pâtisserie",
      "Plats à emporter",
      "Fruits et légumes",
      "Produits de la ferme",
      "Autre – Alimentaire"
    ]
  },
  "bricolage": {
    id: "bricolage",
    name: "Bricolage",
    color: "#f59e0b",
    subcategories: [
      "Électricité",
      "Électroménager",
      "Peinture",
      "Plomberie, chauffage",
      "Mécanique générale",
      "Menuiserie",
      "Restauration de meuble(s)",
      "Prêt de petit outillage",
      "Prêt de gros outillage",
      "Autre – Bricolage"
    ]
  },
  "cours": {
    id: "cours",
    name: "Cours",
    color: "#3b82f6",
    subcategories: [
      "Chant",
      "Comptabilité",
      "Bureautique",
      "CAO DAO graphisme",
      "Couture",
      "Culinaire",
      "Danse",
      "Langues",
      "Musique",
      "Permaculture",
      "Solfège",
      "Yoga",
      "Autre – Cours"
    ]
  },
  "education": {
    id: "education",
    name: "Éducation",
    color: "#8b5cf6",
    subcategories: [
      "Aide niveau primaire",
      "Aide niveau collège",
      "Aide niveau lycée",
      "Aide études supérieures",
      "Autre – Éducation"
    ]
  },
  "espaces-verts": {
    id: "espaces-verts",
    name: "Espaces verts",
    color: "#22c55e",
    subcategories: [
      "Art floral",
      "Compostage",
      "Cueillette",
      "Entretien",
      "Horticulture",
      "Jardinage",
      "Maraîchage",
      "Mise à disposition de terrain",
      "Permaculture",
      "Plants / graines",
      "Autre – Espaces verts"
    ]
  },
  "passions-hobbys": {
    id: "passions-hobbys",
    name: "Passions / hobbys",
    color: "#ec4899",
    subcategories: [
      "Art visuel, cinéma, vidéo",
      "Danse",
      "Littérature",
      "Musique, chant",
      "Peinture, dessin",
      "Sculpture",
      "Théâtre",
      "Univers du cirque",
      "Chercher ensemble",
      "Collections",
      "Jeux",
      "Loisir(s) créatif(s)",
      "Autre – Passions / hobbys"
    ]
  },
  "sante-bien-etre": {
    id: "sante-bien-etre",
    name: "Santé / Bien-être",
    color: "#ef4444",
    subcategories: [
      "Auxiliaire de vie",
      "Conseil en nutrition",
      "Kinésiologie",
      "Kinésithérapie",
      "Orthophonie",
      "Ostéopathie",
      "Pédicurie/Podologie",
      "Psychologie",
      "Sage-femme",
      "Soins infirmiers",
      "Aromathérapie",
      "Cosmétologie naturelle",
      "Homéopathie",
      "Hypnose",
      "Lithothérapie",
      "Massages",
      "Acupuncture",
      "Tai-chi - Qi-Gong",
      "Méditation",
      "Naturopathie",
      "Réflexologie",
      "Relaxation",
      "Bioénergie",
      "Magnétisme / Guérisseur",
      "Reiki",
      "Soins chamaniques",
      "Soins esseniens",
      "Soins par les plantes",
      "Sophrologie",
      "Autre – Santé / Bien-être"
    ]
  },
  "services": {
    id: "services",
    name: "Services",
    color: "#6366f1",
    subcategories: [
      "Aide rédactionnelle",
      "Art divinatoire",
      "Dépannage automobile",
      "Entretien automobile",
      "Lavage, nettoyage véhicule",
      "Mécanique auto",
      "Tôlerie, peinture auto",
      "Bien-être animal",
      "Garder les animaux",
      "Transport d'animaux",
      "Coach de vie",
      "Coach sportif",
      "Coiffure",
      "Conseil",
      "Conseil juridique",
      "Couture / raccommodage",
      "Covoiturage",
      "Esthétique",
      "Faire les courses",
      "Garder les enfants",
      "Aide à la gestion habitat",
      "Décoration intérieure",
      "Décoration extérieure",
      "Énergies habitat",
      "Géobiologie",
      "Gros œuvre",
      "Second œuvre",
      "Terrassement",
      "Livraison",
      "Manutention",
      "Mise à disposition de lieu",
      "Photo, vidéo",
      "Prêt",
      "Aide logicielle",
      "Configuration informatique",
      "Dépannage informatique",
      "Production informatique",
      "Tâches ménagères",
      "Traduction",
      "Autre – Services"
    ]
  },
  "vie-sociale": {
    id: "vie-sociale",
    name: "Vie sociale",
    color: "#14b8a6",
    subcategories: [
      "Activité de groupe",
      "Événementiel",
      "Personne de compagnie",
      "Se promener ensemble",
      "Se rencontrer, boire un café",
      "Autre – Vie sociale"
    ]
  },
  "membre-de": {
    id: "membre-de",
    name: "Membre de",
    color: "#a855f7",
    subcategories: [
      "Alliance Humaine",
      "Bon Sens",
      "Gilets jaunes",
      "Je ne suis pas un danger",
      "Les ballons blancs",
      "LLMP",
      "Mamans Louves",
      "Place d'armes",
      "Pompiers libres",
      "Réaction 19",
      "RéInfo",
      "Rester libre",
      "RSA",
      "Santé en danger",
      "Solaris",
      "Autre – Membre de"
    ]
  },
  "partenaire-alliance-evasion": {
    id: "partenaire-alliance-evasion",
    name: "Partenaire Alliance Evasion",
    color: "#ef4444",
    subcategories: []
  },
  "agriculture": {
    id: "agriculture",
    name: "Agriculture",
    color: "#84cc16",
    subcategories: [
      "Permaculture",
      "Maraîchage",
      "Élevage",
      "Apiculture",
      "Viticulture",
      "Arboriculture",
      "Agriculture urbaine",
      "Autre – Agriculture"
    ]
  },
  "habitat": {
    id: "habitat",
    name: "Habitat",
    color: "#f97316",
    subcategories: [
      "Construction écologique",
      "Rénovation",
      "Tiny house",
      "Habitat partagé",
      "Colocation",
      "Éco-construction",
      "Autre – Habitat"
    ]
  },
  "education-evasion": {
    id: "education-evasion",
    name: "Education",
    color: "#0ea5e9",
    subcategories: [
      "École alternative",
      "Instruction en famille",
      "Ateliers pédagogiques",
      "Formation adultes",
      "Conférences",
      "Autre – Education"
    ]
  },
  "mobilite": {
    id: "mobilite",
    name: "Mobilité",
    color: "#06b6d4",
    subcategories: [
      "Covoiturage",
      "Vélo",
      "Transport solidaire",
      "Auto-stop organisé",
      "Location véhicule",
      "Autre – Mobilité"
    ]
  },
  "sorties": {
    id: "sorties",
    name: "Sorties",
    color: "#f43f5e",
    subcategories: [
      "Randonnée",
      "Visite culturelle",
      "Sortie nature",
      "Événement sportif",
      "Festival",
      "Spectacle",
      "Autre – Sorties"
    ]
  },
  "hebergement": {
    id: "hebergement",
    name: "Hébergement",
    color: "#06b6d4",
    subcategories: [
      "Quelques jours (1-7 jours)",
      "Une semaine",
      "Quelques semaines (2-4 semaines)",
      "Un mois",
      "Plusieurs mois",
      "Longue durée (6+ mois)",
      "Hébergement d'urgence",
      "Colocation",
      "Chambre chez l'habitant",
      "Logement entier",
      "Autre – Hébergement"
    ]
  },
  "voyages": {
    id: "voyages",
    name: "Voyages",
    color: "#8b5cf6",
    subcategories: [
      "Voyage organisé",
      "Road trip",
      "Camping",
      "Hébergement chez l'habitant",
      "Échange de maison",
      "Autre – Voyages"
    ]
  },
  "economie-finance": {
    id: "economie-finance",
    name: "Economie/Finance",
    color: "#eab308",
    subcategories: [
      "Monnaie locale",
      "Troc",
      "SEL (Système d'Échange Local)",
      "Prêt solidaire",
      "Investissement participatif",
      "Comptabilité",
      "Conseil financier",
      "Autre – Economie/Finance"
    ]
  }
};

// Helper functions
export const getAllCategories = () => {
  return Object.values(ALL_CATEGORIES);
};

export const getCategoryById = (categoryId) => {
  return ALL_CATEGORIES[categoryId] || null;
};

export const getSubcategories = (categoryId) => {
  return ALL_CATEGORIES[categoryId]?.subcategories || [];
};

export const getCategoryColor = (categoryId) => {
  return ALL_CATEGORIES[categoryId]?.color || "#6b7280";
};

// Get all categories as a flat list for display
export const getCategoriesList = () => {
  return Object.values(ALL_CATEGORIES).map(cat => ({
    id: cat.id,
    name: cat.name,
    color: cat.color,
    hasSubcategories: cat.subcategories.length > 0
  }));
};
